import { render, staticRenderFns } from "./shipment-billing.vue?vue&type=template&id=2f43b133&scoped=true&"
import script from "./shipment-billing.vue?vue&type=script&lang=js&"
export * from "./shipment-billing.vue?vue&type=script&lang=js&"
import style0 from "./shipment-billing.vue?vue&type=style&index=0&id=2f43b133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43b133",
  null
  
)

export default component.exports